import type { PersonInvolvementKind } from "../types/involvement.js";

/**
 * For an involvement held by an organisation, whether it carries View up to the
 * organisations it is a member of. Keyed by kind so a new involvement kind has
 * to say. Only an organisation's own part in a person's care carries; a
 * `viewer` involvement is to that organisation alone.
 */
export const carriesViewUpByInvolvementKind: Record<
  PersonInvolvementKind,
  boolean
> = {
  duty_of_care: true,
  placement: true,
  created_by: false,
  responsible_user: false,
  designated_assessor: false,
  assessor: false,
  approver: false,
  viewer: false,
  shared_assessment_reader: false,
};
